package games.polyclub.frontend.store.shared

import games.polyclub.service.payment.api.Order
import games.polyclub.tool.strings.Currency
import kotlinx.serialization.Serializable

@Serializable
data class CreateOrderResult(
    val currency: Currency,
    val order: Order?,
    val noPaymentProfile: Boolean = false,
    val removedInvalidData: Boolean = false,
)
